export class AppUtils {
  static validateEmail = (email) => {
    const emailRex = new RegExp(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );

    return emailRex.test(email);
  }

  static validateZipCode = (zipCode) => {
    const zipCodeRegexUS = new RegExp(/^([0-9]{5})(?:[-\s]*([0-9]{4}))?$/);
    const zipCodeRegexCA = new RegExp(/^([A-Z][0-9][A-Z])\s*([0-9][A-Z][0-9])$/);

    return zipCodeRegexUS.test(zipCode) || zipCodeRegexCA.test(zipCode);
  }

  static getDOB = (year) => {
    const currentDate = new Date();
    currentDate.setFullYear(currentDate.getFullYear() - year);
    // If 0 year selected, consider 6months back date as DOB.
    if (year === 0) {
      currentDate.setMonth(currentDate.getMonth() - 6)
    }
    const [yearDOB, month, day] = currentDate.toISOString().split('T')[0].split('-');    
    return encodeURIComponent(`${day}/${month}/${yearDOB}`);
  }
}

export function loadEmbeddedScript({
  onLoadCallback,
  scriptAsync,
  scriptDefer,
  scriptId,
  scriptInnerHTML,
  scriptSrc,
  scriptType = 'text/javascript',
}) {
  if (document.getElementById(scriptId)) {
    return;
  }
  let script = document.createElement('script');
  if (scriptType === 'text/css') {
    script = document.createElement('style');
  }
  script.id = scriptId;
  script.type = scriptType;
  if (scriptSrc) {
    script.src = scriptSrc;
  }

  script.async = scriptAsync;
  script.defer = scriptDefer;

  if (scriptInnerHTML) {
    script.innerHTML = scriptInnerHTML;
  }
  if (onLoadCallback) {
    script.onload = () => onLoadCallback();
  }
  document.body.appendChild(script);
}

export const isProd = process.env.REACT_APP_NAME === 'Prod';
